import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  updateDoc,
  deleteDoc,
  where,
} from "firebase/firestore";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { auth, db } from "../firebase";
import { v4 as uuidv4 } from "uuid";
import { updateProfile, User } from "firebase/auth";
import { toast } from "react-toastify";

export async function storeImage(image: any, currentUser: User) {
  return new Promise((resolve, reject) => {
    const storage = getStorage();
    const filename = `${currentUser.uid}-profile-image-${uuidv4()}`;
    const storageRef = ref(storage, filename);
    console.log("image", image);
    const uploadTask = uploadBytesResumable(storageRef, image);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            console.log("");
        }
      },
      (error) => {
        // Handle unsuccessful uploads
        reject(error);
      },
      () => {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          updateProfile(currentUser, {
            photoURL: downloadURL,
          });

          const docRef = doc(db, "users", currentUser.uid);
          updateDoc(docRef, {
            photoURL: downloadURL,
          });
          resolve(downloadURL);
        });
      }
    );
  });
}

export async function fetchUser(id: string, setUser: any) {
  try {
    const docRef = doc(db, "users", id);
    const snapshot = await getDoc(docRef);

    const user = { ...snapshot.data(), id: snapshot.id };
    setUser(user);
  } catch (error) {
    console.log("error", error);
    toast.error("Could not fetch logged in user");
  }
}

export async function updateCurrentUser(
  name: string,
  country: string,
  city: string,
  reason: string,
  profArea: string,
  availability: string,
  description: string,
  salary: number | string,
  currentUser: User
) {
  //update display name in firebase auth
  await updateProfile(currentUser, {
    displayName: name,
  });

  // update name in the firestore
  const docRef = doc(db, "users", currentUser.uid);
  await updateDoc(docRef, {
    name,
    country: country ?? "",
    city: city ?? "",
    reason: reason ?? null,
    profArea: profArea ?? null,
    availability: availability ?? null,
    description: description ?? "",
    salary: salary ?? "",
  });
}

export async function updateUserConnections(
  currentUser: User,
  connections: string[]
) {
  // update user connections in the firestore
  const docRef = doc(db, "users", currentUser.uid);
  await updateDoc(docRef, {
    connections: connections ?? [],
  });
}

export async function deleteCurrentUser(currentUserId: string) {
  const userDoc = doc(db, "users", currentUserId);
  deleteDoc(userDoc)
    .then(() => {
      console.log("User deleted successfully");
    })
    .catch((error) => {
      console.error("Error deleting user:", error);
    });
}
